import * as React from 'react'
import PropTypes from 'prop-types'
import GridSearchInput from 'containers/requests/components/GridSearchInput/GridSearchInput'
import { PrimeButton } from 'components-design-system'
import './FilesGridTools.scss'

// api
import { useUserPermissions } from 'api/hooks'

const FilesGridTools = ({
  setSearch,
  setAddFilesModalOpen,
  showSearch = true
}) => {
  const { data: permissions } = useUserPermissions()

  return <div className="files-grid-tools">
    {showSearch && <GridSearchInput
      setSearch={setSearch}
      placeholder="Search files"
    />}
    <PrimeButton
      type="add"
      tooltip={permissions?.['document.create'] ? null : 'You do not have sufficient permissions to add files'}
      disabled={!permissions?.['document.create']}
      onClick={() => setAddFilesModalOpen(true)}
    >
      Add file
    </PrimeButton>
  </div>
}

FilesGridTools.propTypes = {
  setSearch: PropTypes.func,
  setAddFilesModalOpen: PropTypes.func,
}

export default FilesGridTools